<template>
  <div class="evaluation-pdf">
    <div v-if="dataReady" id="dataReady" />
    <div class="evaluationReportContent">
      <evaluation-model-header :data="data" :evaluation-data="evaluationData" />
      <div
        class="cardContainer evaluationHeader"
        style="padding: 30px; margin-top: 10px"
      >
        <h4>{{ $t("label_evaluation_report_evaluationSummary") }}</h4>
        <div v-html="evaluationData.evaluation.summary" />
      </div>
      <card-evaluation-report-chart-treemap
        alias="treemap"
        :evaluation="data"
        style="page-break-inside: avoid"
      />
      <div class="cardContainer evaluationHeader" style="padding: 30px;margin-top: 10px;">
        <h4>{{ $t("label_evaluation_report_scoreByDimensions_title") }}</h4>
        <evaluation-report-tree-list :tree="data" />
      </div>
      <div
        class="cardContainer evaluationHeader"
        style="padding: 30px; page-break-inside: avoid"
      >
        <h4>{{ $t("label_evaluation_report_scoreByDimensions_title") }}</h4>
        <evaluation-report-tree-list-graph :tree="data" />
      </div>
      <div class="cardContainer evaluationHeader" style="padding: 30px">
        <h4>{{ $t("label_evaluation_opportunitiesImprovement_title") }}</h4>
        <div v-if="evaluationData.evaluation.improvements">
          <div
            v-for="(improvementE, improvementEIndex) in evaluationData
              .evaluation.improvements"
            :key="improvementEIndex"
            style="
              margin-bottom: 20px;
              border-bottom: 1px solid #636363;
              padding-bottom: 20px;
            "
          >
            <div>
              <h6>
                {{
                  improvementE.evaluation_opportunitiesImprovement_askForTitle
                }}
              </h6>
            </div>
            <div>
              <div>
                <div class="h7">
                  {{
                    $t("label_evaluation_opportunitiesImprovement_whatWasFound")
                  }}
                </div>
              </div>
              <div>
                {{
                  improvementE.evaluation_opportunitiesImprovement_whatWasFound
                }}
              </div>
              <div>
                <div class="h7">
                  {{
                    $t(
                      "label_evaluation_opportunitiesImprovement_whereWasFound"
                    )
                  }}
                </div>
              </div>
              <div>
                {{
                  improvementE.evaluation_opportunitiesImprovement_whereWasFound
                }}
              </div>
              <div>
                <div class="h7">
                  {{
                    $t(
                      "label_evaluation_opportunitiesImprovement_affectedRequirements"
                    )
                  }}
                </div>
              </div>
              <div>
                <div
                  v-for="(req, reqIndex) in improvementE.nodesToImprove"
                  :key="reqIndex"
                  style="page-break-inside: avoid"
                >
                  <b>{{ req.evaluation_administrator_node_nomenclature }}</b>
                  {{ req.evaluation_administrator_node_requirementName }}
                  <!--<div v-if="req.evaluation_administrator_node_matrix_indicator_indicator">
  <div><span>{{$t('Related Indicators')}}</span> {{req.evaluation_administrator_node_matrix_indicator_indicator.id}} - {{req.evaluation_administrator_node_matrix_indicator_indicator.name}}</div>
  <div><span>{{$t('Indicator Value')}}</span> {{req.evaluation_administrator_node_matrix_indicator_indicator.value}}</div>
</div>-->
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        v-if="allComments.length"
        class="cardContainer evaluationHeader"
        style="padding: 30px"
      >
        <h4>
          {{$t("label_evaluation_report_disaggregatedResultsByDimensions_title")}}
        </h4>
        <evaluation-report-comments v-if="data" :tree="data" />
      </div>
    </div>
  </div>
</template>
<script >
import { Tree } from "../../../../utils/vue-tree-list";
import EvaluationModelHeader from "../shared/EvaluationHeader";
import EvaluationReportTreeList from "./EvaluationReportTreeList";
import EvaluationReportTreeListGraph from "./EvaluationReportTreeListGraph";
import EvaluationReportComments from "./EvaluationReportComments";
import { mapGetters } from "vuex";
import { axiosCall } from "../../../../utils/axiosCall";
import CardEvaluationReportChartTreemap
  from "@/components/modules/evaluation/report/CardEvaluationReportChartTreemap.vue";
import {cloneDeep} from "lodash";

export default {
  computed: {
    lang() {
      return this.$i18n.locale;
    },
  },
  ...mapGetters(["getBusiness"]),
  name: "EvaluationModelsRequirements",
  components: {
    EvaluationReportComments,
    EvaluationReportTreeListGraph,
    EvaluationReportTreeList,
    EvaluationModelHeader,
    CardEvaluationReportChartTreemap
  },
  data: function () {
    return {
      today: "",
      data: new Tree([]),
      evaluationId: this.$route.params.evaluationId,
      evaluationData: { evaluation: {} },
      allComments: [],
      status: "success",
      dataReady: false,
    };
  },
  async created() {
    var today = new Date();
    var dd = today.getDate();
    var mm = today.getMonth() + 1; // January is 0!

    var yyyy = today.getFullYear();
    if (dd < 10) {
      dd = "0" + dd;
    }
    if (mm < 10) {
      mm = "0" + mm;
    }
    this.today = yyyy + "-" + mm + "-" + dd;

    if (this.$route.params.lang) {
      this.$store.dispatch("setLangNew", this.$route.params.lang);
    }
    var auth = {
      data: {
        id: this.$route.params.token,
      },
    };
    this.$store.commit("authSuccess", auth);
    await axiosCall({ url: "UserAccounts/get", method: "GET" }).then(
      (account) => {
        this.account = account.data;
      }
    );
    await axiosCall({
      url: "Evaluations/" + this.evaluationId,
      method: "GET",
    }).then((response) => {
      this.evaluationData = response.data;
      this.evaluationData.evaluation.summary = this.evaluationData.evaluation
        .summary
        ? this.evaluationData.evaluation.summary.replace(
            /(?:\r\n|\r|\n)/g,
            "</br>"
          )
        : "";
      if (
        this.evaluationData.evaluation &&
        this.evaluationData.evaluation.children &&
        Array.isArray(this.evaluationData.evaluation.children)
      ) {
        this.data = this.evaluationData.evaluation;
        this.extractAllComments(this.data, []);
        this.$forceUpdate();
      }
      setTimeout(() => {
        this.dataReady = true;
      }, 2000);
    });
  },
  methods: {
    extractAllComments(node, deepTree) {
      if (node.children && node.children.length > 0) {
        if (node.evaluation_administrator_node_requirementName) {
          deepTree.push({
            nom: node.evaluation_administrator_node_nomenclature,
            name: node.evaluation_administrator_node_requirementName,
          });
        }
        node.children.map((child) =>
          this.extractAllComments(child, [...deepTree])
        );
      } else {
        const visibleComments = (node.comments || []).filter(
          (comment) =>
            comment.scope ===
            "label_evaluation_requirementEvaluation_post_includeInFinalReport"
        );
        if (visibleComments.length > 0) {
          this.allComments.push({
            comment: visibleComments,
            indicator:
              node.evaluation_administrator_node_matrix_indicator_indicator,
            tree: deepTree,
          });
        }
      }
    },
  },
};
</script >
<style lang="scss">
@media print {
  .noBreak {
    break-inside: avoid;
  }
}
.evaluation-pdf {
  @for $i from 2 through 30 {
    .node.level-#{$i} {
      display: none;
    }
  }
}

</style>
<style lang="sass">
h4
  font-size: 1.3rem
  text-transform: uppercase
@import "../../../../assets/css/variables"

.cardContainer
  border: 1px solid #000000
  width: 100%
  padding: 30px 40px
  margin-bottom: 15px

.cardContainer  h5
  text-align: center
  width: 100%

.boldH4
  font-family: "Oswald-Bold", sans-serif !important
  font-size: 41px!important
h2
  color: black
  margin: 1em 0

.label
  font-weight: bold
  font-size: 14px

.h7
  font-weight: bold
  margin-top: 15px

.headerEvaluationReportIcon
  height:  230px
  display: flex
  justify-content: center
  align-items: center

.headerEvaluationReportGreen

  left: 0px
  width: 900px
  height: 1044px
  background: #079690 0% 0% no-repeat padding-box
  border: 1px solid #707070
  opacity: 1
  position: relative
h6
  font-family: 'Montserrat-Bold'
</style >
